//src/context/AuthContext.jsx
// src/context/AuthContext.jsx

import { createContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, database } from "../services/firebase";
import { ref, onValue } from "firebase/database";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [isPremium, setIsPremium] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {

      setUser(currentUser);

      if (currentUser) {

        // ✅ FIXED PATH (same as Subscription)
        const subRef = ref(database, `subscriptions/${currentUser.uid}`);

        onValue(subRef, (snap) => {

          if (!snap.exists()) {
            setIsPremium(false);
            setLoading(false);
            return;
          }

          const data = snap.val();
          const expiry = new Date(data.expiryTimestamp);

          if (data.premium && expiry > new Date()) {
            setIsPremium(true);
          } else {
            setIsPremium(false);
          }

          setLoading(false);
        });

      } else {
        setIsPremium(false);
        setLoading(false);
      }

    });

    return () => unsubscribe();

  }, []);

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, logout, isPremium, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};